import { fetchUnguarded, refreshFetch, statusCodeHelperResponse } from './axios';
import { getApiEntrypoint, logger } from 'utils';

interface IRequestExtension {
  tenor: number;
  promise_to_pay_uuid?: string;
}

export const getLoansHistory = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/loan/loan-history';
  const response = await axios({
    method: 'get',
    url: endpoint,
  });
  logger('getLoanById response', response);
  return response;
};

export const getActiveLoan = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/loan/active';

  const response = await axios({
    method: 'get',
    url: endpoint,
  });
  logger('getActiveLoan response', response);
  return await statusCodeHelperResponse(response);
};

export const requestExtension = async (data: IRequestExtension) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/extension/request';

  const response = await axios({
    method: 'post',
    url: endpoint,
    data,
  });
  logger('requestExtension response', response);
  return await statusCodeHelperResponse(response);
};

// NOTE: OTP was removed as a requred step for requesting extension
export const confirmExtension = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/extension/confirm';

  const response = await axios({
    method: 'post',
    url: endpoint,
  });
  logger('confirmExtension response', response);
  return await statusCodeHelperResponse(response);
};

export const requestExtensionAnonym = async (data: IRequestExtension, loanUuid: string) => {
  const axiosUnguarded = fetchUnguarded();
  const endpoint = `/fo/v1/extension/${loanUuid}/anonymized-request`;

  const response: any = await axiosUnguarded({
    baseURL: getApiEntrypoint(),
    method: 'post',
    url: endpoint,
    data,
  });
  logger('requestExtensionAnonym response', response);
  return await statusCodeHelperResponse(response);
};

export const confirmExtensionAnonym = async (loanUuid: string) => {
  const axiosUnguarded = fetchUnguarded();
  const endpoint = `/fo/v1/extension/${loanUuid}/anonymized-confirm`;

  const response: any = await axiosUnguarded({
    baseURL: getApiEntrypoint(),
    method: 'post',
    url: endpoint,
  });
  logger('confirmExtensionAnonym response', response);

  return await statusCodeHelperResponse(response);
};

export const getTotalPayment = async (payload: any) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/loan/amounts';

  const response = await axios({
    method: 'post',
    url: endpoint,
    data: payload,
  });
  logger('getTotalPayment response', response);

  return await statusCodeHelperResponse(response);
};

export const changeAutoProlongTenor = async (payload: any) => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/extension/tenor';

  const response = await axios({
    method: 'patch',
    url: endpoint,
    data: payload,
  });
  logger('changeAutoProlongTenor response', response);
  return await statusCodeHelperResponse(response);
};

export const cancelAutoProlong = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/extension/revert';

  const response = await axios({
    method: 'post',
    url: endpoint,
  });
  logger('cancelAutoProlong response', response);
  return await statusCodeHelperResponse(response);
};

export const getDiscounts = async () => {
  const axios = refreshFetch();
  const endpoint = '/fo/v1/loan/manual-client-discounts';
  const response = await axios({
    method: 'get',
    url: endpoint,
  });
  logger('getDiscounts response', response);
  return await statusCodeHelperResponse(response);
};

export const chooseDiscounts = async (loanUuid: string, discountId: number) => {
  const axiosUnguarded = fetchUnguarded();

  const endpoint = '/fo/v1/loan/manual-client-discounts';
  const response = await axiosUnguarded({
    method: 'post',
    url: endpoint,
    data: { loan_uuid: loanUuid, discount_campaign: discountId },
  });
  logger('chooseDiscounts response', response);
  return await statusCodeHelperResponse(response);
};
